module.exports = require("number-to-words");